import styles from "./PolicyPlainContent.module.css";

interface PolicyPlainContentProps {
  text: string;
  bold?: boolean;
}

export default function PolicyPlainContent({
  text,
  bold = false,
}: PolicyPlainContentProps): JSX.Element {
  return (
    <div className={`${styles.text} ${bold ? styles.bold : styles.normal}`}>
      {text}
    </div>
  );
}
